/* eslint-disable guard-for-in */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import _ from 'lodash';
import countryCodes from 'shared/constant/countryCodes';
import ArrowIcon from 'assets/icons/icon-dropdown.svg';
import './CountryCodeDropdown.scss';

function CountryCodeDropdown({
  value,
  onChange = () => {},
}) {
  const [selected, setSelected] = useState(value);
  const [isOpenOptions, setIsOpenOptions] = useState(false);
  const [dummyInput, _setDummyInput] = useState('');
  const listContainerRef = useRef(null);
  const dummyInputRef = useRef(dummyInput);
  const setDummyInput = (inputVal) => {
    dummyInputRef.current = inputVal;
    _setDummyInput(inputVal);
  };
  const dummyInputElemRef = useRef(null);

  const selectedValue = useMemo(() => {
    if (!selected) return null;
    const filteredItem = countryCodes.find(item => item.isoCode === selected);
    return filteredItem;
  }, [selected]);

  const onHandleChange = (event, item) => {
    setSelected(item.isoCode);
    setIsOpenOptions(false);
    setDummyInput(null);
    onChange(item);
    event.stopPropagation();
  };

  const handleKeyDown = (event) => {
    if (event.code === 'Escape') {
      setIsOpenOptions(false);
    } else if (event.keyCode >= 48 && event.keyCode <= 57) {
      setDummyInput((dummyInputRef.current || '') + event.key);
    } else {
      setDummyInput(null);
    }
  };

  const handleClick = () => {
    setIsOpenOptions(false);
    setDummyInput(null);
  };

  const filteredCountryCodes = useMemo(() => {
    if (dummyInput?.length && listContainerRef?.current) {
      let result = countryCodes.filter(item => item.dialCode.substring(1).startsWith(dummyInput));
      // eslint-disable-next-line no-restricted-syntax
      for (const i in dummyInput) {
        result = result.concat(countryCodes.filter(item => item.dialCode.substring(1).startsWith(dummyInput[i])));
      }
      return _.uniqBy(result, 'dialCode');
    }
    return countryCodes;
  }, [dummyInput]);

  useEffect(() => {
    if (isOpenOptions) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('click', handleClick);
      dummyInputElemRef.current.focus();
      setTimeout(() => {
        listContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Wait a bit to virtual keyboard showup
      }, 300);
    } else {
      setDummyInput(null);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
      setDummyInput(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenOptions]);

  return (
    <div className="country-select">
      <input
        type="number"
        className="dummy-input"
        ref={dummyInputElemRef}
      />
      <div
        className="country-selected"
        style={{ backgroundImage: `url(${ArrowIcon})` }}
        onClick={() => {
          setIsOpenOptions(true);
          dummyInputElemRef.current.focus();
        }}
      >
        <img src={selectedValue.flag} alt={selectedValue.isoCode} />
        <span>{selectedValue.dialCode}</span>
      </div>
      {isOpenOptions ? (
        <div ref={listContainerRef} className="select-option-container">
          {filteredCountryCodes.map((item, idx) => (
            <div
              key={idx}
              id={item.isoCode}
              className="select-option-item"
              onClick={(event) => { onHandleChange(event, item); }}
            >
              <img src={item.flag} alt={item.isoCode} />
              <span>{item.dialCode}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default CountryCodeDropdown;
